import Icon from 'src/components/Icon/Icon.component';
import Translate from 'src/components/Translate/Translate.component';
import { ReactComponent as Email } from 'src/images/icons/email.svg';
import colors from 'src/style-utils/colors';
import { H5, P } from 'src/style-utils/typographic';
import { Card } from 'src/style/Container.style';
import { Flex } from 'src/style/flexbox.style';
import { StyleSheetManager } from 'styled-components';
import { shouldForwardProp } from 'src/style-utils/functions';

const SupportCard1 = () => {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <Card>
        <Icon
          svgIconComponent={Email}
          iconSize="5rem"
          marginBottom="1.2rem"
          color={colors.textColorGrey}
        />
        <H5 marginBottom="0.5rem">
          <Translate id="supportPage.CardTitle1" />
        </H5>
        <P>
          <Translate id="supportPage.CardContent1" />
        </P>
      </Card>
    </StyleSheetManager>
  );
};

const SupportCards = () => {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <Flex
        data-component="support-cards"
        flexDirection="column"
        gap="2.4rem"
        marginBottom="3em"
      >
        <SupportCard1 />
      </Flex>
    </StyleSheetManager>
  );
};

export default SupportCards;
